<div class="sso-container">
    <div class="sso-card" style="padding: 3rem 0rem">
        <div class="sso-header" style="margin-bottom: 0px">
            <div *ngIf="callbackData.code" class="rubii-logo-container">
                <img class="rubii-logo-animated" src="assets/images/logo-animated.svg?v1" alt="Rubii">
            </div>

            <p *ngIf="callbackData.code" class="rubii-loading-text">Authenticating<span class="dot">.</span><span class="dot">.</span><span class="dot">.</span></p>
            
            <div *ngIf="callbackData.error" class="error-content">
                <p class="subtitle" style="color: #f44336;">Authentication Failed</p>
                <p class="error-message">
                    {{ callbackData.error_description || callbackData.error }}
                </p>
                <button mat-raised-button color="primary" class="rubii-btn" (click)="goBackToLogin()">
                    Go back to Login
                </button>
            </div>
        </div>
    </div>
</div>
